<div class="itServicesCards" id="itservice">
    <div class="cardsHeader">
        <p>why choose LOT </p>
        <h2>Managed IT services customized for <span class="txtColor">your industry</span></h2>
    </div>
    <div class="innerCardWrapper">
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="cardWrapper1">
                        <div class="imageSection">
                            <img src="assets/images//icon1.png" alt="">
                            <img src="assets/images//icon4.png" alt="">
                        </div>
                        <div class="informationTxt">
                            <h2>Advanced AI</h2>
                            <p>Turn our AI research into your organization’s value with tools like Cloud AutoML,
                                Cloud Natural Language…</p>
                            <a>Discover now <span><i class="fa fa-long-arrow-right"></i></span> </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="cardWrapper2">
                        <div class="imageSection">
                            <img src="assets/images//icon2.png" alt="">
                            <img src="assets/images//icon5.png" alt="">
                        </div>
                        <div class="informationTxt">
                            <h2>Experts in deployed AI</h2>
                            <p>Turn our AI research into your organization’s value with tools like Cloud AutoML,
                                Cloud Natural Language…</p>
                            <a>Discover now <span><i class="fa fa-long-arrow-right"></i></span> </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="cardWrapper3">
                        <div class="imageSection">
                            <img src="assets/images//icon3.png" alt="">
                            <img src="assets/images//icon6.png" alt="">
                        </div>
                        <div class="informationTxt">
                            <h2>Advanced AI</h2>
                            <p>Turn our AI research into your organization’s value with tools like Cloud AutoML,
                                Cloud Natural Language…</p>
                            <a>Discover now <span><i class="fa fa-long-arrow-right"></i></span> </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>